import { useCallback, useState } from 'react';
import { getAxiosClient } from '#shared/api/axiosClient';
import { MESSAGES } from '../utils/constant';
const useCreateGlossary = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const createGlossary = useCallback(async data => {
    setLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);
    try {
      const axiosClient = getAxiosClient();
      const response = await axiosClient.post('glossary', data);
      setSuccessMessage(MESSAGES.success.create);
      return response.data;
    } catch (error) {
      if (error?.isAxiosError) {
        const message = error.response?.data?.error?.message;
        const errorText = message || MESSAGES.error.default;
        setErrorMessage(errorText);
        return errorText;
      } else {
        setErrorMessage(MESSAGES.error.create);
      }
    } finally {
      setLoading(false);
    }
  }, []);
  return {
    createGlossary,
    loading,
    errorMessage,
    successMessage
  };
};
export default useCreateGlossary;